"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var use_pusher_1 = require("@harelpls/use-pusher");
var react_2 = require("react");
var SpeechBubble_1 = __importDefault(require("./SpeechBubble"));
function ChatSpeechBubble(_a) {
    var gameId = _a.gameId, player = _a.player, props = __rest(_a, ["gameId", "player"]);
    var channel = (0, use_pusher_1.useChannel)("game=".concat(gameId));
    var _b = (0, react_2.useState)(''), message = _b[0], setMessage = _b[1];
    (0, use_pusher_1.useEvent)(channel, 'message', function (message) {
        if (message && player.userId === message.userId) {
            setMessage(message.text);
        }
    });
    var hideMessage = function () { return setMessage(''); };
    (0, react_2.useEffect)(function () {
        if (message) {
            var timeout_1 = setTimeout(hideMessage, 3000);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [message]);
    var onClick = function (event) {
        hideMessage();
        event.stopPropagation();
    };
    return message ? (0, jsx_runtime_1.jsx)(SpeechBubble_1.default, __assign({ css: chatSpeechBubbleCss, onClick: onClick }, props, { children: message })) : null;
}
exports.default = ChatSpeechBubble;
var fadeOut = (0, react_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  to {\n    opacity: 0\n  }\n"], ["\n  to {\n    opacity: 0\n  }\n"])));
var chatSpeechBubbleCss = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation: 1s ", " 2s forwards;\n"], ["\n  animation: 1s ", " 2s forwards;\n"])), fadeOut);
var templateObject_1, templateObject_2;
//# sourceMappingURL=ChatSpeechBubble.js.map